<div
  class="form-control__wrapper"
  [ngClass]="{
    'form-control__wrapper--inline': direction === 'row',
    'form-control__wrapper--filter': direction === 'filter',
  }"
>
  <label class="form-control__label">
    <p class="t-data t-bold" data-test-id="companyAddressLabel">
      {{ config.label }}
    </p>
  </label>

  <div
    [formGroup]="formGroup"
    [ngClass]="{ 'address-group__controls': !!config.grid }"
  >
    <form-control
      direction="grouping"
      [libGridCell]="address1Config.grid"
      [config]="address1Config"
      [control]="formGroup.get(address1Config.prop)"
      data-test-id="companyAddress1"
    >
    </form-control>

    <form-control
      direction="grouping"
      [libGridCell]="address2Config.grid"
      [config]="address2Config"
      [control]="formGroup.get(address2Config.prop)"
      data-test-id="companyAddress2"
    >
    </form-control>

    @if (!config.populateCity) {
      <form-control
        direction="grouping"
        [libGridCell]="cityConfig.grid"
        [config]="cityConfig"
        [control]="formGroup.get(cityConfig.prop)"
        data-test-id="companyCity"
      >
      </form-control>
    }

    <form-control
      direction="grouping"
      [libGridCell]="zipCodeConfig.grid"
      [config]="zipCodeConfig"
      [control]="formGroup.get(zipCodeConfig.prop)"
      data-test-id="companyZipCode"
    >
    </form-control>

    @if (config.populateCity) {
      <cities
        [libGridCell]="cityConfig.grid"
        [formControlName]="cityConfig.prop"
        [config]="cityDropdownConfig"
        [group]="formGroup"
        data-test-id="companyCityDropdown"
      >
      </cities>
    }

    <counties
      [libGridCell]="countyConfig.grid"
      [formControlName]="countyConfig.prop"
      [config]="countyCodeConfig"
      [group]="formGroup"
      data-test-id="companyCounty"
    >
    </counties>

    <form-control
      [stateAutoComplete]="formGroup"
      direction="grouping"
      [libGridCell]="stateConfig.grid"
      [config]="stateConfig"
      [control]="formGroup.get(stateConfig.prop)"
      data-test-id="companyState"
    >
    </form-control>
  </div>
</div>
